import { render, staticRenderFns } from "./MedicineLoad.vue?vue&type=template&id=a4b755f2"
import script from "./MedicineLoad.js?vue&type=script&lang=js&external"
export * from "./MedicineLoad.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports